import fetch from '@/utils/fetch';

export function getEnterpriseList(params) {
  return fetch({
    url: 'Qiye/Qiye/getEnterpriseByWhere',
    method: "post",
    data: params
  });
}

export function getEnterpriseAttes(params) {
  return fetch({
    url: 'Qiye/Qiye/getEnterpriseById',
    method: "post",
    data: params
  });
}

export function attesUptate(params) {
  return fetch({
    url: 'Qiye/Qiye/updateStatusEnterprise',
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/attes/attestation.js